import { useState } from "react";
import { toast } from "sonner";
import { Send } from "lucide-react";
import { api, formatApiError } from "../lib/api";
import { Input } from "./ui/input";
import { Textarea } from "./ui/textarea";

const EMPTY = { from_name: "", from_email: "", company: "", phone: "", body: "" };

export const ContactForm = ({ slug, name }) => {
  const [form, setForm] = useState(EMPTY);
  const [sending, setSending] = useState(false);
  const [sent, setSent] = useState(false);
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setSending(true);
    try {
      await api.post(`/extras/${slug}/contact`, form);
      setSent(true);
      setForm(EMPTY);
      toast.success("Message sent");
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setSending(false);
    }
  };

  if (sent) {
    return (
      <div className="border border-primary/50 p-8" data-testid="contact-success">
        <p className="font-display text-2xl">Message sent</p>
        <p className="text-white/60 mt-2 text-sm">{name} will reply to you by email.</p>
      </div>
    );
  }

  return (
    <form onSubmit={submit} className="border border-white/10 p-6 md:p-8 space-y-4" data-testid="contact-form">
      <p className="label-xs">Message {name}</p>
      <div className="grid sm:grid-cols-2 gap-4">
        <Input required placeholder="Your name" value={form.from_name} onChange={set("from_name")} data-testid="contact-name-input" />
        <Input required type="email" placeholder="Your email" value={form.from_email} onChange={set("from_email")} data-testid="contact-email-input" />
        <Input placeholder="Production / company (optional)" value={form.company} onChange={set("company")} data-testid="contact-company-input" />
        <Input placeholder="Phone (optional)" value={form.phone} onChange={set("phone")} data-testid="contact-phone-input" />
      </div>
      <Textarea required minLength={5} rows={5} placeholder="Shoot dates, location, role details…" value={form.body} onChange={set("body")} data-testid="contact-message-input" />
      <button disabled={sending} className="bg-primary text-primary-foreground px-6 py-3.5 font-bold uppercase text-sm tracking-wider inline-flex items-center gap-2 hover:bg-[hsl(43,100%,60%)] transition-colors disabled:opacity-60" data-testid="contact-submit-button">
        <Send size={16} /> {sending ? "Sending…" : "Send message"}
      </button>
    </form>
  );
};
